import { Modal } from "react-bootstrap";
import {yes, no} from '../../resources/string/strings'
import { ReactComponent as IconCLose } from "../../resources/image/ic_cross_gray.svg";

export default function VerticalModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      className="modal"
      dir="rtl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="text-right mr-0 ml-auto" >
      <Modal.Title style={{float: "right"}} className="mr-auto" id="contained-modal-title-vcenter">
          {props.title}
        </Modal.Title>

        <IconCLose 
             style={{float: "left", color: "GrayText"}}
                    className="p-0 clickable"
                    width="16"
                    height="16"
                    fill="gray"
                    color="gray"
                    onClick={() => props.onHide(false)}
                  />
      </Modal.Header>
      <Modal.Body className="text-right mr-0 ml-auto">
        <p>{props.description}</p>
      </Modal.Body>
      <Modal.Footer className="text-left ml-0 mr-auto">
        <div className="btn btn-danger px-4" onClick={() => props.onHide(false)}>
          {no}
        </div>
        <div className="btn btn-primary  px-4" onClick={() => props.onHide(true)}>
          {yes}
        </div>
      </Modal.Footer>
    </Modal>
  );
}